const ExtraInfo = Object.freeze({
  NONE: 'NONE',
  SENTIMENT: 'SENTIMENT',
  TIMELINE_NOTES: 'TIMELINE_NOTES'
})
export default ExtraInfo
export type ExtraInfoStrings = typeof ExtraInfo[keyof typeof ExtraInfo]
// RESERVE BELOW
